var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity"},[_c('div',{staticClass:"bg-top"}),_c('div',{staticClass:"container"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"list"},[_c('div',{staticClass:"list-right"},[_c('img',{attrs:{"src":item.img,"alt":""},on:{"click":function($event){return _vm.toGame()}}})])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }